import { render, staticRenderFns } from "./contributors.vue?vue&type=template&id=7b957a16"
import script from "./contributors.vue?vue&type=script&lang=js"
export * from "./contributors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports